import productStats from "../product-page/product-stats";
import collectionPageAccordion from "./collection-accordion";
import collectionMobileNav from "./collection-mobile-nav";

const initializeCollectionFilters = () => {
  const filterSections = document.querySelectorAll('[data-collection-filter-enabled="true"]');

  filterSections.forEach((section) => {
    const filterInputs = Array.from(section.querySelectorAll('.collection-filter__input'));
    const productCards = Array.from(section.querySelectorAll('.product-card'));
    const clearFiltersButton = section.querySelector('.collection-filters__clear');
    const emptyState = section.querySelector('.collection-products__empty-state');
    const totalEl = section.querySelector('.collection-total');
    const paginationEl = section.querySelector('.collection-products__pagination');
    const sortForm = section.querySelector('#CollectionControls');
    const filterParam = section.getAttribute('data-collection-filter-param') || 'collection_filter';
    let hiddenFilterInput = sortForm ? sortForm.querySelector('[name="' + filterParam + '"]') : null;

    if (!filterInputs.length || !productCards.length || !totalEl) {
      return;
    }

    if (sortForm && !hiddenFilterInput) {
      hiddenFilterInput = document.createElement('input');
      hiddenFilterInput.type = 'hidden';
      hiddenFilterInput.name = filterParam;
      sortForm.appendChild(hiddenFilterInput);
    }

    const productsText = totalEl.getAttribute('data-products-text') || '';
    const defaultTotal = totalEl.getAttribute('data-default-total') || productCards.length.toString();

    const getSelectedHandles = () => {
      return Array.from(new Set(
        filterInputs
          .filter((input) => input.checked)
          .map((input) => input.value)
          .filter(Boolean)
      ));
    };

    const syncFilterInputState = () => {
      filterInputs.forEach((input) => {
        const filterOption = input.closest('.collection-links__filter');

        if (filterOption) {
          filterOption.classList.toggle('is-active', input.checked);
        }
      });

      if (clearFiltersButton) {
        const hasActiveFilters = filterInputs.some((input) => input.checked);

        clearFiltersButton.classList.toggle('is-hidden', !hasActiveFilters);
        clearFiltersButton.setAttribute('aria-hidden', String(!hasActiveFilters));
        clearFiltersButton.disabled = !hasActiveFilters;
      }
    };

    const updateUrlState = (selectedHandles) => {
      const url = new URL(window.location.href);

      if (selectedHandles.length) {
        url.searchParams.set(filterParam, selectedHandles.join(','));
      } else {
        url.searchParams.delete(filterParam);
      }

      window.history.replaceState({}, '', url.toString());

      if (hiddenFilterInput) {
        hiddenFilterInput.value = selectedHandles.join(',');
      }
    };

    const updateTotal = (visibleCount, hasActiveFilters) => {
      const count = hasActiveFilters ? visibleCount : defaultTotal;
      totalEl.textContent = [count, productsText].join(' ').trim();
    };

    const applyFilters = () => {
      const selectedHandles = getSelectedHandles();
      const hasActiveFilters = selectedHandles.length > 0;
      let visibleCount = 0;

      productCards.forEach((productCard) => {
        const productHandles = (productCard.getAttribute('data-collection-handles') || '')
          .split(',')
          .filter(Boolean);
        const isMatch = !hasActiveFilters || selectedHandles.some((handle) => productHandles.includes(handle));

        productCard.hidden = !isMatch;
        productCard.classList.toggle('product-card--filtered-out', !isMatch);
        productCard.style.display = isMatch ? '' : 'none';
        productCard.setAttribute('aria-hidden', isMatch ? 'false' : 'true');

        if (isMatch) {
          visibleCount += 1;
        }
      });

      syncFilterInputState();
      updateTotal(visibleCount, hasActiveFilters);

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }

      if (paginationEl) {
        paginationEl.hidden = hasActiveFilters;
      }

      section.classList.toggle('collection-products-section--filters-active', hasActiveFilters);
      updateUrlState(selectedHandles);
    };

    const params = new URLSearchParams(window.location.search);
    const selectedFromUrl = new Set((params.get(filterParam) || '').split(',').filter(Boolean));

    if (selectedFromUrl.size) {
      filterInputs.forEach((input) => {
        input.checked = selectedFromUrl.has(input.value);
      });
    }

    filterInputs.forEach((input) => {
      input.addEventListener('change', applyFilters);
    });

    if (clearFiltersButton) {
      clearFiltersButton.addEventListener('click', () => {
        filterInputs.forEach((input) => {
          input.checked = false;
        });

        applyFilters();
      });
    }

    applyFilters();
  });
};

const initializeCollectionSort = () => {
  const sortDisclosures = Array.from(document.querySelectorAll('.collection-sort'));

  if (!sortDisclosures.length) {
    return;
  }

  document.addEventListener('click', (event) => {
    sortDisclosures.forEach((sortDisclosure) => {
      if (sortDisclosure.open && !sortDisclosure.contains(event.target)) {
        sortDisclosure.open = false;
      }
    });
  });
};

const updateCollectionCardPrices = (toggleInput) => {
  document.querySelectorAll('.product-card').forEach((productCard) => {
    const oneTimePrice = productCard.getAttribute('data-price');
    const subscriptionPrice = productCard.getAttribute('data-subscription-price');
    const comparePrice = productCard.getAttribute('data-compare-at-price');
    const oneTimeServingsPrice = productCard.getAttribute('data-one-time-servings-price');
    const subscriptionServingsPrice = productCard.getAttribute('data-subscription-servings-price');
    const servingsText = productCard.getAttribute('data-servings-text');

    const elPriceOneTime = productCard.querySelector('.product-card__price--one-time');
    const elPriceSubscription = productCard.querySelector('.product-card__price--subscription');
    const elPriceCompare = productCard.querySelector('.product-card__price--compare');
    const elPricePerServing = productCard.querySelector('.product-card__price-per-serving');
    const elSubSavings = productCard.querySelector('.product-card__savings');

    if (!elPriceOneTime || !elPriceSubscription || !elPriceCompare || !elPricePerServing || !elSubSavings) {
      return;
    }

    if (toggleInput.checked) {
      elPriceOneTime.style.display = 'none';
      elPriceSubscription.style.display = 'block';
      elPricePerServing.textContent = subscriptionServingsPrice + ' ' + servingsText;
      elPriceCompare.style.display = comparePrice > 0 ? 'block' : 'none';
      elSubSavings.style.display = 'block';
    } else {
      elPriceOneTime.style.display = 'block';
      elPriceSubscription.style.display = 'none';
      elPricePerServing.textContent = oneTimeServingsPrice + ' ' + servingsText;
      elSubSavings.style.display = 'none';

      if (comparePrice > oneTimePrice) {
        elPriceCompare.style.display = 'block';
      } else {
        elPriceCompare.style.display = 'none';
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  productStats();
  collectionPageAccordion();
  collectionMobileNav();
  initializeCollectionFilters();
  initializeCollectionSort();

  const toggleWrapper = document.querySelector('.collection-topper__toggle');
  const toggleInput = toggleWrapper ? toggleWrapper.querySelector('.toggle__input') : null;

  document.querySelectorAll('.add-to-cart--collection').forEach(button => {
    const productCard = button.closest('.product-card');

    if (!productCard) {
      return;
    }

    const variantId = productCard.getAttribute('data-variant-id');
    const sellingPlanId = productCard.getAttribute('data-selling-plan-id');

    button.addEventListener('click', async () => {
      if (!variantId || button.disabled) {
        return;
      }

      let activeSellingPlanId = sellingPlanId;
      if (!toggleInput || !toggleInput.checked) {
        activeSellingPlanId = null;
      }

      button.disabled = true;

      try {
        const itemsToAdd = [{
          id: variantId,
          quantity: 1,
          selling_plan: activeSellingPlanId
        }];

        await addItemsToCartWithDrawer(itemsToAdd);
      } catch (err) {
        console.error('Cart update failed:', err);
      } finally {
        button.disabled = false;
      }
    });
  });

  if (toggleInput) {
    toggleInput.addEventListener('change', () => {
      updateCollectionCardPrices(toggleInput);
    });
  }

  if (toggleWrapper && toggleInput) {
    toggleWrapper.addEventListener('click', (event) => {
      if (event.target.closest('.toggle')) {
        return;
      }

      toggleInput.checked = !toggleInput.checked;
      toggleInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  async function addItemsToCartWithDrawer(items) {
    const requestItems = (items || [])
      .filter((item) => item && item.id)
      .map((item) => {
        const requestItem = {
          id: item.id,
          quantity: item.quantity || 1
        };

        if (typeof item.selling_plan !== 'undefined' && item.selling_plan !== null && item.selling_plan !== 'null') {
          requestItem.selling_plan = item.selling_plan;
        }

        return requestItem;
      });

    if (!requestItems.length) {
      throw new Error('Add to cart failed: missing line items');
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: requestItems })
    });

    if (!response.ok) {
      let errorMessage = 'Add to cart failed';

      try {
        const errorData = await response.json();
        if (errorData && errorData.description) {
          errorMessage = errorData.description;
        }
      } catch (err) {
        errorMessage = 'Add to cart failed';
      }

      throw new Error(errorMessage);
    }

    await response.json();

    const inlineCart = document.querySelector('.inline-cart');
    const inlineCartPageOverlay = document.querySelector('.inline-cart__page-overlay');

    if (inlineCart) {
      inlineCart.classList.add('active');
    }

    if (inlineCartPageOverlay) {
      inlineCartPageOverlay.classList.add('active');
    }

    document.body.classList.add('body--no-scroll');
  }

  async function fetchCartData() {
    const response = await fetch('/cart.js');

    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }

    return response.json();
  }
});